import styled from 'styled-components'
import { Button as AntButton, Form } from 'antd'
import { SPACING, TYPOGRAPHY } from '../../../styles/theme'

/**
 * Styled components for LoginForm component
 * Replaces inline styles with reusable styled components
 */

// Form item with reduced bottom margin (8px)
export const FormItemReduced = styled(Form.Item)`
  margin-bottom: ${SPACING.sm};
`

// Form item with medium bottom margin (16px)
export const FormItemMedium = styled(Form.Item)`
  margin-bottom: ${SPACING.lg};
`

// Form item with no bottom margin
export const FormItemNoMargin = styled(Form.Item)`
  margin-bottom: 0;
`

// Link button with zero padding, auto height, and small font size
export const LinkButton = styled(AntButton)`
  padding: 0;
  height: auto;
  font-size: ${TYPOGRAPHY.body.fontSize};
`

// Full width button
export const FullWidthButton = styled(AntButton)`
  width: 100%;
`
